import { render, staticRenderFns } from "./LandPageSlider.vue?vue&type=template&id=56afcf98&scoped=true"
import script from "./LandPageSlider.vue?vue&type=script&lang=js"
export * from "./LandPageSlider.vue?vue&type=script&lang=js"
import style0 from "./LandPageSlider.vue?vue&type=style&index=0&id=56afcf98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56afcf98",
  null
  
)

export default component.exports